import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as legalEntitiesForUserReducer from '../reducers/legal-entities-for-user.reducer';
import { legalEntitiesForUserKey } from '../reducers/legal-entities-for-user.reducer';

import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region CHECK REGISTRASTION SUB STATE
export const getLegalEntitiesForUserState = createSelector(getAuthState, state => state[legalEntitiesForUserKey]);

export const getLegalEntitiesForUserIsLoading = createSelector(
  getLegalEntitiesForUserState,
  legalEntitiesForUserReducer.getIsLegalEntitiesForUserLoading
);

export const getLegalEntitiesForUserSuccess = createSelector(
  getLegalEntitiesForUserState,
  legalEntitiesForUserReducer.getLegalEntitiesForUserSuccess
);
export const getLegalEntitiesForUserFailure = createSelector(
  getLegalEntitiesForUserState,
  legalEntitiesForUserReducer.getLegalEntitiesForUserFailure
);
//#endregion
